import {
    FULL_BOOKING_EXPORT,
    FULL_BOOKING_EXPORT_FAILURE,
    FULL_BOOKING_EXPORT_SUCCESS,
} from 'store/actions/types';

export const exportFullBookings = (params) => {
    return {
        type: FULL_BOOKING_EXPORT,
        params: params,
    };
};

export const exportFullBookingsFailure = () => {
    return {
        type: FULL_BOOKING_EXPORT_FAILURE,
        error: true,
    };
};

export const exportFullBookingsSuccess = () => {
    return {
        type: FULL_BOOKING_EXPORT_SUCCESS,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/bookings/fullBookingExport.js